export const SECURITY_SET_USER_INFO = 'SECURITY_SET_USER_INFO';
export const SECURITY_GET_ACCESS_INFO = 'SECURITY_GET_ACCESS_INFO';
export const SECURITY_CUSTOMIZE_NAVIGATION_MENU =
  'SECURITY_CUSTOMIZE_NAVIGATION_MENU';
export const SECURITY_SET_ACCESS_INFO_LOADING =
  'SECURITY_SET_ACCESS_INFO_LOADING';

export const SECURITY_LOG_OUT = 'SECURITY_LOG_OUT';



// WEBPACK FOOTER //
// ./src/common/Security/state/types.js